// Weeknight stubs — 30-45 min, low effort, high reward. The
// recurring tag fires Mon-Thu evenings. Most are co-tagged with
// kids or comfort-food.

export const WEEKNIGHT_STUBS = [
  {
    id: "sheet-pan-chicken-fajitas",
    title: "Sheet Pan Chicken Fajitas",
    emoji: "🌯",
    blurb: "Charred chicken and peppers in one pan",
    discoveryTags: ["weeknight", "kids", "meal-prep", "comfort-food"],
    cuisine: "mexican",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 35,
    keyIngredients: ["chicken_breast", "bell_pepper", "onion", "flour_tortilla", "lime", "cumin"],
    buildHint: "high heat 450F for char, toss chicken and peppers with spice rub + oil, single layer on sheet, finish with lime and cilantro, warm tortillas in foil",
    producesCanonical: null,
  },
  {
    id: "spaghetti-bolognese",
    title: "Spaghetti Bolognese",
    emoji: "🍝",
    blurb: "Slow-simmered meat sauce over spaghetti",
    discoveryTags: ["weeknight", "kids", "comfort-food", "sunday-dinner"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 60,
    keyIngredients: ["ground_beef", "spaghetti", "tomato_sauce", "onion", "garlic"],
    buildHint: "brown beef hard for fond, soffritto of onion + carrot + celery, simmer with crushed tomato 45 min, finish with parmesan and basil",
    producesCanonical: null,
  },
  {
    id: "stir-fry-chicken",
    title: "Chicken Stir-Fry",
    emoji: "🥢",
    blurb: "Wok-tossed chicken and vegetables, soy-ginger sauce",
    discoveryTags: ["weeknight", "kids", "meal-prep"],
    cuisine: "chinese",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["chicken_breast", "broccoli", "soy_sauce", "ginger", "garlic", "rice"],
    buildHint: "wok screaming hot, batch the protein and veg so the pan doesn't drop temp, simple sauce of soy + cornstarch slurry + sesame oil",
    producesCanonical: null,
  },
  {
    id: "teriyaki-salmon-bowl",
    title: "Teriyaki Salmon Bowl",
    emoji: "🐟",
    blurb: "Glazed salmon over rice with edamame",
    discoveryTags: ["weeknight", "meal-prep", "date-night"],
    cuisine: "japanese",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["salmon", "rice", "soy_sauce", "ginger", "edamame"],
    buildHint: "make teriyaki glaze from soy + mirin + sugar + ginger reduced to syrup, sear salmon skin-down for crisp, baste with glaze final 2 min",
    producesCanonical: null,
  },
  {
    id: "shrimp-scampi",
    title: "Shrimp Scampi",
    emoji: "🦐",
    blurb: "Garlic-butter shrimp over linguine",
    discoveryTags: ["weeknight", "date-night", "comfort-food"],
    cuisine: "italian",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["shrimp", "linguine", "butter", "garlic", "white_wine", "lemon"],
    buildHint: "sear shrimp 90 seconds per side and pull, build sauce with garlic + wine + lemon + butter emulsion, toss pasta in sauce off heat",
    producesCanonical: null,
  },
  {
    id: "pad-thai",
    title: "Pad Thai",
    emoji: "🍜",
    blurb: "Tamarind-glazed rice noodles, peanuts, lime",
    discoveryTags: ["weeknight", "date-night"],
    cuisine: "thai",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 35,
    keyIngredients: ["rice_noodles", "shrimp", "tamarind", "fish_sauce", "peanuts", "lime", "bean_sprouts"],
    buildHint: "soak noodles to al dente before tossing in wok, sauce is tamarind + fish sauce + palm sugar to taste, finish with lime, peanuts, sprouts",
    producesCanonical: null,
  },
];
